<template>
  <span>
    <sidebar-module-info
      ref="sidebarModuleInfo"
      module-name="failures"
      permissions-path="FAILURES"
      :filtered-attributes="filteredAttributes"
      :module-objects="failures"
      :get-object="getFailureObject"
      :handle-object-adding="handleFailureAdding"
      :handle-object-deleting="handleFailureDeleting"
      :handle-object-editing="handleFailureEditing"
      :inputs="inputs"
      :new-object-payload="newFailureObject"
      :toggle-object-adding="toggleFailureAdding"
      :zoom-to-object="zoomToFailure"
      :name-attribute="
        attrSchemaMetadata[currentLayerSourceName]
          ? attrSchemaMetadata[currentLayerSourceName].attributes_schema.desc_attribute_name
          : ''
      "
      has-back-button
      has-basic-attributes
      :has-assigned-objects="false"
    >
      <template #status="scope">
        <sidebar-status-select v-bind="scope" v-model="scope.payload[scope.name]" />
      </template>
      <template #assigned_user="scope">
        <user-select v-bind="scope" v-model="scope.payload[scope.name]" />
      </template>
      <template #reported_by="scope">
        <user-select v-bind="scope" v-model="scope.payload[scope.name]" />
      </template>
      <template #geometry="scope">
        <sidebar-geometry-input
          v-bind="scope"
          v-model="scope.payload[scope.name]"
          :is-valid.sync="scope.slotsValid[scope.name]"
        />
      </template>
    </sidebar-module-info>
  </span>
</template>
<script>
import { call, get } from 'vuex-pathify';

import SidebarGeometryInput from '@/components/SidebarGeometryInput';
import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import SidebarStatusSelect from '@/components/SidebarStatusSelect';
import UserSelect from '@/components/UserSelect';

export default {
  name: 'Failure',
  components: {
    SidebarGeometryInput,
    SidebarModuleInfo,
    SidebarStatusSelect,
    UserSelect,
  },
  data: () => ({
    filteredAttributes: [
      'id',
      'status',
      'assigned_user',
      'reported_by',
      'description',
      'name',
      'due_date',
      'reported_at',
    ],
  }),
  computed: {
    failures: get('failures/failures'),
    dataSource: get('admin/modulesMapping@failures.datasource_name'),
    currentLayerFormSchema: get('layers/currentLayer@form_schema'),
    dataSourcesForms: get('layers/dataSourcesForms@:dataSource'),
    currentUser: get('users/currentUser'),
    users: get('users/users'),
    attrSchemaMetadata: get('layers/metadata'),
    currentLayerSourceName: get('layers/currentLayer@data_source_name'),
    newFailureObject() {
      const dateNow = this.$dayjs();
      const dateNowIsoString = dateNow.format('YYYY-MM-DDTHH:mm[:00.000Z]');
      if (!this.currentUser.is_superadmin && Object.keys(this.users).includes(this.currentUser.id.toString())) {
        return { reported_by: this.currentUser.id, reported_at: dateNowIsoString.slice(0, -1) };
      }
      return {};
    },
    inputs() {
      return {
        new: [
          {
            name: 'status',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            hasDivider: true,
            cols: 'auto',
            type: 'failures',
            colors: {
              new: {
                color: 'rgba(191,54,12)',
                shadowColor: 'rgba(191,54,12,0.2)',
              },
              completed: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              active: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
              planned: {
                color: 'rgba(108,108,108)',
                shadowColor: 'rgba(108,108,108,0.2)',
              },
            },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'name',
            translationPath: 'dialog.name',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'description',
            translationPath: 'dialog.description',
            icon: 'mdi-information',
            dataType: { name: 'textarea' },
            autoGrow: true,
            dense: true,
            rows: '1',
            hasDivider: true,
          },
          {
            name: 'due_date',
            translationPath: 'dialog.timeLimit',
            icon: 'mdi-calendar',
            dataType: { name: 'date' },
          },
          {
            name: 'assigned_user',
            translationPath: 'dialog.assignedPerson',
            icon: 'mdi-account-arrow-left',
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            cols: '12',
            hint: this.$i18n.t('dialog.failureGeometryInputHint'),
            hasDivider: true,
            geometryType: 'Polygon',
          },
        ],
        edit: [
          {
            name: 'status',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            hasDivider: true,
            cols: 'auto',
            type: 'failures',
            colors: {
              new: {
                color: 'rgba(191,54,12)',
                shadowColor: 'rgba(191,54,12,0.2)',
              },
              completed: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              active: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
              planned: {
                color: 'rgba(108,108,108)',
                shadowColor: 'rgba(108,108,108,0.2)',
              },
            },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'name',
            translationPath: 'dialog.name',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'description',
            translationPath: 'dialog.description',
            icon: 'mdi-information',
            dataType: { name: 'textarea' },
            autoGrow: true,
            dense: true,
            rows: '1',
            hasDivider: true,
          },
          {
            name: 'due_date',
            translationPath: 'dialog.timeLimit',
            icon: 'mdi-calendar',
            dataType: { name: 'date' },
          },
          {
            name: 'assigned_user',
            translationPath: 'dialog.assignedPerson',
            icon: 'mdi-account-arrow-left',
            hasDivider: true,
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            oneLineInput: false,
            cols: '12',
            hint: this.$i18n.t('dialog.failureGeometryInputHint'),
            hasDivider: true,
            geometryType: 'Polygon',
          },
          {
            name: 'reported_by',
            translationPath: 'dialog.reportingPerson',
            icon: 'mdi-account-arrow-right',
            rules: [v => !!v || v == '0' || this.$i18n.t('rules.required')],
            readOnlyField: true,
          },
          {
            name: 'reported_at',
            translationPath: 'dialog.reportedAt',
            icon: 'mdi-calendar',
            dataType: { name: 'datetime' },
            rules: [v => !!v || v == '0' || 'rules.required'],
            hasDivider: true,
            readOnlyField: true,
          },
        ],
      };
    },
  },
  methods: {
    addFailure: call('failures/addFailure'),
    deleteFailure: call('failures/deleteFailure'),
    editFailure: call('failures/editFailure'),
    getFailure: call('failures/getFailure'),
    toggleFailureAdding() {
      this.$router.push({
        name: 'failure',
        params: { fid: 'new' },
      });
    },
    zoomToFailure(layerId, layerGroup, featureId) {
      this.$root.$emit('zoomToFeature', layerId, layerGroup, featureId);
    },
    async getFailureObject(id) {
      const r = await this.getFailure(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    async handleFailureAdding(payload) {
      const feature = {
        ...payload,
      };
      const r = await this.addFailure(feature);
      this.$root.$emit('refreshNavbarInfoButtons', ['failures']);
      return r.data.data;
    },
    async handleFailureDeleting(payload) {
      await this.deleteFailure(payload);
      this.$root.$emit('refreshNavbarInfoButtons', ['failures']);
    },
    async handleFailureEditing(payload) {
      const failure_id = payload.id;
      delete payload.id;
      if (payload.assigned_user === null) {
        delete payload.assigned_user;
      }
      const feature = {
        ...payload,
      };
      await this.editFailure({ failure_id, feature });
    },
  },
};
</script>
